import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 113 113",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M56.5 0A5.49 5.49 0 0 0 51 5.5V51H5.5C2.453 51 0 53.453 0 56.5S2.453 62 5.5 62H51v45.5c0 3.047 2.453 5.5 5.5 5.5s5.5-2.453 5.5-5.5V62h45.5c3.047 0 5.5-2.453 5.5-5.5s-2.453-5.5-5.5-5.5H62V5.5C62 2.453 59.547 0 56.5 0" })
});
export default SvgPlus;
